exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CodeViewer-module_CodeViewerContainer_2U2ja {\n    height: 52vh;\n    width: 100%;\n    /* border: 1px solid hsla(0, 0%, 0%, 0.1); */\n    /* border-radius: 10px; */\n}\n", ""]);

// exports
exports.locals = {
	"CodeViewerContainer": "CodeViewer-module_CodeViewerContainer_2U2ja",
	"codeViewerContainer": "CodeViewer-module_CodeViewerContainer_2U2ja"
};